import { Provider } from "@angular/core";
import * as services from "./services";

export function providedAttachments(): Array<Provider>
{
    return [
        services.AttachmentsDialogService,
        services.AttachmentService,
        services.DocumentService,
    ];
}
